import type { AppDispatch, AppState } from 'app/redux/types/types';
import { RequestStatus } from 'app/pages/order/redux/model/order-request';

import { updatePendingRequestsActionCreator } from './update-pending-requests-action-creator';

export const clearPendingOrderRequestsActionCreator = () => (dispatch: AppDispatch, getState: () => AppState) => {
    const {
        order: { orderRequests },
    } = getState();

    const updatedOrderRequests = orderRequests.filter((request) => request.status !== RequestStatus.PENDING);

    dispatch(updatePendingRequestsActionCreator(updatedOrderRequests));
};
